export const DEFAULT_STROKE_PATTERN = [1, 4];
